import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';

Vue.use(Vuetify, {
  iconfont: 'faSvg',
  theme: {
    white: '#ECEFF1',
    grey: '#4D4D4D',
    silver: '#90A4AE',
    main: '#303030',
  },
});
